const STRICT_STRIP_REGEX = /[.-]/g;
const LOOSE_STRIP_REGEX = /[^\d]/g;

export function isValidCUIT(number: string, strict?: boolean): boolean {
  const stripped: string = strip(number, strict);
  if (!stripped) return false;
  if (stripped.length !== 11) return false;
  const [checkDigit, ...rest] = stripped.split('').map(Number).reverse();
  const total = rest.reduce((acc, cur, index) => acc + cur * (2 + (index % 6)), 0);
  const mod11 = 11 - (total % 11);
  if (mod11 === 11) return checkDigit === 0;
  if (mod11 === 10) return checkDigit === 9;
  return checkDigit === mod11;
}

function strip(number: string, strict?: boolean): string {
  const regex: RegExp = strict ? STRICT_STRIP_REGEX : LOOSE_STRIP_REGEX;
  return (number || '').replace(regex, '');
}
